import {getLocale} from '@locale';

export function getLocaleStr(name): string {
  if (!name) {
    return '';
  }
  let nameObj = name;
  if (name && typeof name === 'string') {
    try {
      nameObj = JSON.parse(name);
    } catch (e) {
      return name;
    }
  }
  if (!nameObj) {
    return '';
  }
  const feLocale = (getLocale()).replace('-', '_');
  if (nameObj.i18nValue && nameObj.i18nValue[feLocale]) {
    return nameObj.i18nValue[feLocale];
  }
  return nameObj?.i18nValue?.en_US || nameObj.defaultValue || '';
}
